import React from 'react';
const MediaPage = () => {
  return <div className="bg-color-paper min-h-screen w-full" data-id="element-612">
      {/* Hero Section */}
      <div className="relative h-[60vh] overflow-hidden flex items-center justify-center bg-gradient-to-b from-green-900/10 to-[var(--color-paper)]" data-id="element-613">
        <div className="absolute inset-0 z-0" data-id="element-614">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2St8j7dtP7wGSk7uTwFS99/ayira_s_neuro_soul_cafe_cover.jpg" alt="Ayira's Cafe featured in media" className="w-full h-full object-cover opacity-20" data-id="element-615" />
        </div>
        <div className="container mx-auto px-6 z-10 relative" data-id="element-616">
          <div className="max-w-4xl mx-auto text-center" data-id="element-617">
            <div className="inline-block mb-6 px-6 py-2 bg-green-100 text-green-800 rounded-full font-medium" data-id="element-618">
              Media Coverage
            </div>
            <h1 className="text-5xl md:text-6xl font-poppins font-medium mb-6 tracking-tight" data-id="element-619">
              Media <span className="text-[var(--color-accent-1)]" data-id="element-620">Voices</span>
            </h1>
            <p className="text-xl font-poppins font-light max-w-2xl mx-auto" data-id="element-621">
              What the press is saying about Africa's first neurodivergent café
            </p>
          </div>
        </div>
      </div>
      {/* Media Quotes Grid */}
      <section className="py-16 px-6" data-id="element-622">
        <div className="container mx-auto max-w-6xl" data-id="element-623">
          <div className="mb-16 text-center" data-id="element-624">
            <h2 className="text-3xl font-poppins font-medium mb-4" data-id="element-625">
              Media Coverage
            </h2>
            <div className="jp-divider asymmetric" data-id="element-626"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-627">
            {/* BBC News Africa */}
            <div className="mb-8" data-id="element-628">
              <MediaQuoteCard outlet="BBC News Africa" quote="Happy Mother's Day! Diana Ayoo created a café inspired by her neurodiverse daughter Ayira…" headline="Video profiling Diana and Ayira's mission" data-id="element-629" />
            </div>
            {/* Voice of America */}
            <div className="mb-8" data-id="element-630">
              <MediaQuoteCard outlet="Voice of America (VOA) Africa" quote="Diana Ayoo… opened Ayira's Neuro-Soul Café as a haven for people with neurological disorders… providing employment and education." headline="Kenyan Café Employs People with Cognitive Disorders" data-id="element-631" />
            </div>
            {/* Capital FM Kenya */}
            <div className="mb-8" data-id="element-632">
              <MediaQuoteCard outlet="Capital FM Kenya" quote="Kenya's first neuro-divergent café owner Diana Ayoo" headline="Radio Interview on DriveInn Feature" data-id="element-633" />
            </div>
            {/* KTN Home */}
            <div className="mb-8" data-id="element-634">
              <MediaQuoteCard outlet="KTN Home" quote="This week on #TheHotSpot – Ayira's Neuro Soul Café is the first Neuro-divergent café in Kenya renowned for hiring members of staff diagnosed with neuro-diverse challenges." headline="Ayira's Neuro Soul Café Feature" data-id="element-635" />
            </div>
            {/* NTV Kenya */}
            <div className="mb-8" data-id="element-636">
              <MediaQuoteCard outlet="NTV Kenya" quote="Ayira's café hires members of staff diagnosed with neuro-diverse challenges." headline="Special Restaurant for a Special Reason" data-id="element-637" />
            </div>
            {/* Nation.co.ke */}
            <div className="mb-8" data-id="element-638">
              <MediaQuoteCard outlet="Nation.co.ke" quote="Ayira's Café has become renowned for hiring members of staff diagnosed with neuro-diverse challenges." headline="Popular Kenyan Restaurant that Employs Staff With Neuro Challenges" data-id="element-639" />
            </div>
          </div>
        </div>
      </section>
      {/* Award Recognition */}
      <section className="py-20 px-6 nature-gradient-amber" data-id="element-640">
        <div className="container mx-auto max-w-4xl" data-id="element-641">
          <div className="washi-container p-12" data-id="element-642">
            <div className="text-center mb-8" data-id="element-643">
              <h2 className="text-3xl font-poppins font-medium" data-id="element-644">
                Award Recognition
              </h2>
              <div className="jp-divider asymmetric" data-id="element-645"></div>
            </div>
            <div className="flex flex-col md:flex-row items-center" data-id="element-646">
              <div className="md:w-1/3 mb-8 md:mb-0" data-id="element-647">
                <div className="relative" data-id="element-648">
                  <div className="w-32 h-32 mx-auto rounded-full bg-amber-100 flex items-center justify-center" data-id="element-649">
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="text-amber-600" data-id="element-650">
                      <circle cx="12" cy="8" r="7" data-id="element-651"></circle>
                      <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" data-id="element-652"></polyline>
                    </svg>
                  </div>
                  <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center opacity-10" data-id="element-653">
                    <div className="w-40 h-40 rounded-full border border-amber-600 animate-pulse" data-id="element-654"></div>
                  </div>
                </div>
              </div>
              <div className="md:w-2/3 md:pl-12" data-id="element-655">
                <h3 className="text-2xl font-poppins font-medium mb-4 text-center md:text-left" data-id="element-656">
                  DIAR Awards – Top National Inclusion Champion 2024
                </h3>
                <p className="text-lg font-poppins font-light mb-6" data-id="element-657">
                  Diana was honored as the Top National Inclusion Champion,
                  highlighting her leadership in advancing neurodiversity
                  inclusion in Kenya.
                </p>
                <div className="wabi-sabi-border" data-id="element-658">
                  <p className="text-center text-sm font-poppins font-medium" data-id="element-659">
                    Recognition for excellence in inclusion and advocacy
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Social Media Section */}
      <section className="py-20 px-6" data-id="element-660">
        <div className="container mx-auto max-w-4xl text-center" data-id="element-661">
          <h2 className="text-3xl font-poppins font-medium mb-4" data-id="element-662">
            Follow Our Journey
          </h2>
          <div className="jp-divider asymmetric" data-id="element-663"></div>
          <p className="text-lg font-poppins font-light mb-10 max-w-2xl mx-auto" data-id="element-664">
            Connect with us on social media and join the conversation about
            neurodiversity inclusion.
          </p>
          <div className="flex flex-wrap justify-center gap-6" data-id="element-665">
            <SocialButton icon="instagram" data-id="element-666" />
            <SocialButton icon="facebook" data-id="element-667" />
            <SocialButton icon="twitter" data-id="element-668" />
          </div>
        </div>
      </section>
    </div>;
};
const MediaQuoteCard = ({
  outlet,
  quote,
  headline
}) => {
  return <div className="media-card washi-container p-8 h-full" data-id="element-669">
      <div className="mb-4" data-id="element-670">
        <span className="text-lg font-poppins font-medium text-[var(--color-accent-1)]" data-id="element-671">
          {outlet}
        </span>
      </div>
      <div data-id="element-672">
        <h3 className="text-xl font-poppins font-medium mb-4" data-id="element-673">{headline}</h3>
        <p className="media-quote text-lg mb-4 font-poppins font-light" data-id="element-674">
          "{quote}"
        </p>
      </div>
    </div>;
};
const SocialButton = ({
  icon
}) => {
  let iconSvg;
  switch (icon) {
    case 'instagram':
      iconSvg = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-675">
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-676"></rect>
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-677"></path>
          <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-678"></line>
        </svg>;
      break;
    case 'facebook':
      iconSvg = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-679">
          <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" data-id="element-680"></path>
        </svg>;
      break;
    case 'twitter':
      iconSvg = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-681">
          <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" data-id="element-682"></path>
        </svg>;
      break;
    default:
      iconSvg = null;
  }
  return <a href="#" className="w-14 h-14 rounded-full border border-[var(--color-ink)] flex items-center justify-center hover:bg-[var(--color-ink)] hover:text-white transition-colors duration-300" data-id="element-683">
      {iconSvg}
    </a>;
};
export default MediaPage;